import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/webapp/src/app/error.tsx");
